import { IconButton, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import {
  TableContentItemBadge,
  TableContentItemCaptions,
} from '../../../../../../components/TableContent';
import { messageError } from '../../../../../../store/batchTicket/constants';
import { mapCaptions } from '../../../../utils';
import { CustomerItemTagObject } from '../../../../utils/types';
import { ItemTag } from '../../../Customer/components/ItemTag';

import { RequiredAttentionResponsiveItem } from '.';

export const RequiredAttentionItemMobile: React.FC<RequiredAttentionResponsiveItem> = ({
  handleDetailsCustomer,
  detailsButtonIsDisabled,
  sectionIsOpened,
  toggleSection,
  item,
}) => {
  return (
    <Shadow borderRadius={BoxRadius.xs} level={2}>
      <VStack space={Spacing['inline.xxxs']} p={Spacing['inline.xxs']} borderRadius={BoxRadius.xs}>
        <HStack alignItems="center" justifyContent="space-between">
          <VStack>
            <Text
              noOfLines={1}
              variant="semibold"
              fontSize={Typography['fontsize.md']}
              color="neutral.darkest">
              {item?.customer?.customerName || messageError}
            </Text>
            <HStack space={Spacing['inline.nano']} alignItems="center">
              <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                Conta
              </Text>
              <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                {item?.customer?.account?.accountNumber || messageError}
              </Text>
              <TableContentItemCaptions forceDesktop icons={mapCaptions(item?.customer)} />
            </HStack>
          </VStack>
          <TableContentItemBadge>
            {item?.customer?.suitabilityProfileName || messageError}
          </TableContentItemBadge>
        </HStack>
        <HStack alignItems={'center'} justifyContent={'space-between'}>
          <Text fontSize={Typography['fontsize.md']} color="neutral.black">
            Hashtag
          </Text>
          <ItemTag
            isListing
            data={(item?.customer?.hashtags as unknown as CustomerItemTagObject[]) || []}
            itemId={item?.customer?.customerId}
          />
        </HStack>
        {item?.errors && item?.errors.length > 0 && (
          <VStack
            borderRadius={BoxRadius.sm}
            backgroundColor={Utils.ColorToken.WithOpacity('background', 'opacity.semiopaque')}
            space={Spacing['stack.xxxs']}
            w={'full'}
            p={Spacing['inline.xxxs']}>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text fontSize={Typography['fontsize.md']} color="neutral.darkest" variant="semibold">
                Itens que Requerem atenção
              </Text>
              <IconButton
                icon={sectionIsOpened ? 'ChevronUp' : 'ChevronDown'}
                testId="section-toggle"
                onPress={toggleSection}
                iconColor={Color['neutral.black']}
              />
            </HStack>
            {sectionIsOpened && (
              <VStack space={Spacing['inline.xxxs']}>
                <Box h="1px" w={'full'} bg={'neutral.lightest'} />
                {item.errors?.map((error) => (
                  <VStack key={error?.errorId} space={Spacing['inline.nano']}>
                    <Text
                      fontSize={Typography['fontsize.md']}
                      color="neutral.darkest"
                      variant="semibold">
                      {error?.errorTitle || messageError}
                    </Text>
                    <Text
                      fontSize={Typography['fontsize.md']}
                      color="neutral.darkest"
                      variant="regular">
                      {error?.errorMessage && error?.errorSuggest
                        ? `${error?.errorMessage} ${error?.errorSuggest}`
                        : messageError}
                    </Text>
                  </VStack>
                ))}
              </VStack>
            )}
          </VStack>
        )}
        <IconButton
          alignSelf={'flex-end'}
          testId="details-icon-button"
          borderRadius={BoxRadius.sm}
          isDisabled={detailsButtonIsDisabled}
          icon="ArrowRight"
          onPress={handleDetailsCustomer}
          p={0}
          iconColor={
            Color[detailsButtonIsDisabled ? 'neutral.darkest' : 'brand.tertiary.principal']
          }
          iconSize="xs"
        />
      </VStack>
    </Shadow>
  );
};
